import { FilterConfig } from 'common/models/filter.model';
import { UNIVERSAL_FILTER } from './constants-universal-filters';
import { FILTER_ITEMS } from './constants-filter-configs';

export const REPORT_FILTERS: FilterConfig[] = [...UNIVERSAL_FILTER, FILTER_ITEMS.categoryStatus];
